export default "__VITE_ASSET__CVvpMJui__"